import { COMPANY_TABS, COMPANY_TAB_PERMISSIONS, type CompanyTab } from '../company-settings.paths';

/** The tabs a user may open, in tab order. Hiding the rest is UX only; each tab's endpoint is guarded by the same permission. */
export function companyTabsFor(permissions: readonly string[]): CompanyTab[] {
  return COMPANY_TABS.filter((tab) => permissions.includes(COMPANY_TAB_PERMISSIONS[tab]));
}
